import React from "react";
import AntModal from "antd/es/modal";
import { ConfigProvider } from "antd";

interface ModalProps {
  open: boolean;
  closeIcon?: React.ReactNode;
  title: React.ReactNode;
  onCancel: () => void;
  onOk?: () => void;
  footer?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  closable?: boolean;
  centered?: boolean;
  loading?: boolean;
  style?: React.CSSProperties;
  width?: number;
  afterClose?: () => void;
  wrapClassName?: string;
  destroyOnClose?: boolean;
  mask?: boolean;
  maskClosable?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const AntDModal: React.FC<ModalProps> & {
  info: typeof AntModal.info;
  success: typeof AntModal.success;
  error: typeof AntModal.error;
  warning: typeof AntModal.warning;
  confirm: typeof AntModal.confirm;
} = ({ open, title, onCancel, onOk, centered = true, ...props }) => {
  return (
    <AntModal
      open={open}
      title={title}
      onCancel={onCancel}
      onOk={onOk}
      centered={centered}
      {...props}
      className=" !z-[99999999]"
    >
      {props.children}
    </AntModal>
  );
};

AntDModal.info = AntModal.info;
AntDModal.success = AntModal.success;
AntDModal.error = AntModal.error;
AntDModal.warning = AntModal.warning;
AntDModal.confirm = AntModal.confirm;
